/*
  NordicVend: lagerbadgens, recensionspanelens och energietikettens skript
  (snippets/PRODUCT-BADGES.liquid).
  Låg tidigare inline i snippeten. Som egen fil cachas den mellan sidvisningar.
  Laddas med defer från snippeten. Värden från Liquid läses från skripttaggens
  data-attribut (document.currentScript), så filen innehåller ingen Liquid.
*/
(function () {
  var badge    = document.getElementById('nvRvOpen');
  var overlay  = document.getElementById('nvRvOverlay');
  var panel    = document.getElementById('nvRvPanel');
  var closeBtn = document.getElementById('nvRvClose');
  var widget   = document.getElementById('nvRvWidget');
  var loading  = document.getElementById('nvRvLoading');
  if (!badge || !overlay || !panel || !widget) return;

  // Flytta overlay och panel till <body> så de aldrig hamnar
  // "instängda" i en förälder med overflow:hidden eller egen z-index.
  NVPanel.toBody(overlay, panel);

  // Widgeten laddas först när besökaren visar intresse (hovrar, fokuserar
  // eller öppnar panelen), så den inte gör produktsidan långsammare.
  var loaded = false;
  function loadWidget() {
    if (loaded) return;
    loaded = true;

    // Dölj "Laddar recensioner…" så fort Trustindex ritat ut något.
    if (loading && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        var kids = widget.children;
        for (var i = 0; i < kids.length; i++) {
          var tag = kids[i].tagName;
          if (kids[i] !== loading && tag !== 'SCRIPT' && tag !== 'LINK' && tag !== 'STYLE') {
            loading.style.display = 'none';
            mo.disconnect();
            return;
          }
        }
      });
      mo.observe(widget, { childList: true });
    }

    // Laddningen och schemarensningen: snippets/NV-TRUSTINDEX.liquid
    NVTrustindex.load(widget, 'recensioner');
  }

  /* Stängd panel är inert (går inte att tabba till och syns inte för
     skärmläsare). Öppen panel: fokus flyttas in, Tab stannar i panelen,
     Escape stänger och fokus går tillbaka till badgen. */
  var lastFocus = null;
  function openPanel() {
    if (panel.classList.contains('is-open')) return;
    NVPanel.opening('reviews');
    loadWidget();
    lastFocus = document.activeElement;
    panel.removeAttribute('inert');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    badge.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nv-rv-no-scroll');
    if (closeBtn) closeBtn.focus();
  }
  function closePanel() {
    if (!panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
    overlay.classList.remove('is-open');
    badge.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nv-rv-no-scroll');
    var back = lastFocus && document.contains(lastFocus) && badge.contains(lastFocus) ? lastFocus : badge;
    if (back && typeof back.focus === 'function') back.focus({ preventScroll: true });
    lastFocus = null;
  }

  // Capture, så att klick var som helst på badgen (även inuti Trustindex
  // egen widget) öppnar panelen i stället för att följa en länk.
  badge.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    openPanel();
  }, true);
  badge.addEventListener('mouseenter', loadWidget, { once: true });
  badge.addEventListener('focusin', loadWidget, { once: true });
  badge.addEventListener('touchstart', loadWidget, { once: true, passive: true });

  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  overlay.addEventListener('click', closePanel);
  /* Escape och Tab: NVPanel (snippets/NV-PANEL-CORE.liquid) */
  NVPanel.keys(function () { return panel.classList.contains('is-open') ? panel : null; }, closePanel);
  NVPanel.register('reviews', function () { return panel.classList.contains('is-open'); }, closePanel);
})();

/* Energietiketten i popup. Märket är en knapp med länken i data-nv-el-src.
   En PDF ritas som bild (sida 1) med pdf.js, som laddas först vid första
   klicket. Bildlänkar visas som <img> utan pdf.js. Resultatet sparas för
   sidvisningen. Går etiketten inte att visa får kunden en länk i rutan. */
(function () {
  var btn      = document.getElementById('nvElOpen');
  var modal    = document.getElementById('nvElModal');
  var overlay  = document.getElementById('nvElOverlay');
  var stage    = document.getElementById('nvElStage');
  var loading  = document.getElementById('nvElLoading');
  var closeBtn = document.getElementById('nvElClose');
  if (!btn || !modal || !overlay || !stage || !closeBtn) return;
  NVPanel.toBody(overlay, modal);

  var src = btn.getAttribute('data-nv-el-src');
  var isPdf = btn.getAttribute('data-nv-el-pdf') === '1';
  var alt = stage.getAttribute('data-nv-el-alt') || '';
  var isOpen = false;
  var hideTimer = null;
  var shown = null;   // canvas eller img när etiketten är klar
  var pageW = 0;      // etikettens mått i punkter, för storleken
  var pageH = 0;
  var started = false;

  // asset_url kan ge en adress utan protokoll (//domän/...)
  function abs(url) {
    return url && url.indexOf('//') === 0 ? location.protocol + url : url;
  }

  // Största yta för etiketten: 80 % av höjden och 92 % av bredden minus kortets luft
  function maxBox() {
    var cs = getComputedStyle(modal);
    var padX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    var padY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var vh = window.innerHeight;
    return {
      w: Math.max(100, vw * 0.92 - padX),
      h: Math.max(100, Math.min(vh * 0.8, vh - 16 - padY))
    };
  }

  function fit() {
    if (!shown || !pageW || !pageH) return;
    var box = maxBox();
    var scale = Math.min(box.w / pageW, box.h / pageH);
    // Bara bredden, höjden följer bildens proportioner (height: auto)
    shown.style.width = Math.floor(pageW * scale) + 'px';
  }

  function show(el, w, h) {
    shown = el;
    pageW = w;
    pageH = h;
    if (loading) loading.hidden = true;
    stage.appendChild(el);
    fit();
  }

  // Reserv: en länk till etiketten i rutan (samma flik, inga nya flikar på sajten)
  var fallbackEl = null;
  function fallback() {
    if (shown || fallbackEl) return;
    if (loading) loading.hidden = true;
    fallbackEl = document.createElement('p');
    fallbackEl.className = 'nv-el-fallback';
    fallbackEl.setAttribute('role', 'status');
    fallbackEl.appendChild(document.createTextNode('Etiketten kunde inte visas här. '));
    var a = document.createElement('a');
    a.href = src;
    a.textContent = 'Öppna etiketten';
    fallbackEl.appendChild(a);
    stage.appendChild(fallbackEl);
  }

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = url;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function renderPdf() {
    var timedOut = false;
    var timer = setTimeout(function () { timedOut = true; fail(); }, 15000);
    function fail() {
      clearTimeout(timer);
      if (shown) return;
      if (isOpen) fallback();
      else started = false;
    }
    var lib = window.pdfjsLib ? Promise.resolve() : loadScript(abs(btn.getAttribute('data-nv-pdfjs')));
    lib.then(function () {
      var pdfjs = window.pdfjsLib || window['pdfjs-dist/build/pdf'];
      if (!pdfjs) throw new Error('pdf.js saknas');
      pdfjs.GlobalWorkerOptions.workerSrc = abs(btn.getAttribute('data-nv-pdfjs-worker'));
      return pdfjs.getDocument({ url: src, isEvalSupported: false }).promise;
    }).then(function (doc) {
      return doc.getPage(1);
    }).then(function (page) {
      if (timedOut) return;
      var base = page.getViewport({ scale: 1 });
      var box = maxBox();
      var fitScale = Math.min(box.w / base.width, box.h / base.height);
      // Minst dubbel upplösning, så att etiketten är skarp även vid zoom
      var ratio = Math.max(window.devicePixelRatio || 1, 2);
      var viewport = page.getViewport({ scale: fitScale * ratio });
      var canvas = document.createElement('canvas');
      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);
      canvas.setAttribute('role', 'img');
      canvas.setAttribute('aria-label', alt);
      var ctx = canvas.getContext('2d');
      return page.render({ canvasContext: ctx, viewport: viewport }).promise.then(function () {
        if (timedOut) return;
        clearTimeout(timer);
        show(canvas, base.width, base.height);
      });
    }).catch(fail);
  }

  function renderImg() {
    var img = new Image();
    img.decoding = 'async';
    img.alt = alt;
    img.onload = function () { show(img, img.naturalWidth, img.naturalHeight); };
    img.onerror = function () { if (isOpen) fallback(); else started = false; };
    img.src = src;
  }

  function open() {
    if (isOpen) return;
    NVPanel.opening('energietikett');
    clearTimeout(hideTimer);
    overlay.hidden = false;
    modal.hidden = false;
    fit();
    // En bildruta i dolt läge först, så att övergången syns
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        modal.classList.add('is-open');
      });
    });
    isOpen = true;
    btn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nv-el-open');
    try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
    if (!started) {
      started = true;
      if (isPdf) renderPdf(); else renderImg();
    }
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    modal.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nv-el-open');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    hideTimer = setTimeout(function () {
      overlay.hidden = true;
      modal.hidden = true;
    }, reduce ? 0 : 200);
    try { btn.focus({ preventScroll: true }); } catch (e) { btn.focus(); }
  }

  btn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  // Klick på den mörka bakgrunden stänger, klick i det vita kortet gör det inte
  overlay.addEventListener('click', close);
  window.addEventListener('resize', function () { if (isOpen) fit(); });
  /* Escape och Tab: NVPanel (snippets/NV-PANEL-CORE.liquid) */
  NVPanel.keys(function () { return isOpen ? modal : null; }, close);
  NVPanel.register('energietikett', function () { return isOpen; }, close);
})();
